import { useEffect, useState } from "react";
import { useSubscription } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { TYPING_CHANGED } from "./queries";

interface Props {
  conversationId: string;
  currentUserId: string;
  otherName: string;
}

export function TypingIndicator({ conversationId, currentUserId, otherName }: Props) {
  const { t } = useTranslation();
  const [typing, setTyping] = useState(false);

  useSubscription(TYPING_CHANGED, {
    variables: { conversationId },
    onData: ({ data }) => {
      const evt = data.data?.typingChanged;
      if (!evt || evt.userId === currentUserId) return;
      setTyping(evt.isTyping);
    },
  });

  useEffect(() => {
    if (!typing) return;
    const timer = setTimeout(() => setTyping(false), 4000);
    return () => clearTimeout(timer);
  }, [typing]);

  if (!typing) return null;

  return (
    <div className="text-xs text-muted-foreground italic px-4 py-1">
      {t("chat.typing", { name: otherName })}
    </div>
  );
}
